import { BaseModel } from "sjs-base-model";

export default class IstitutoFinanziarioModel extends BaseModel {
    public readonly codiceRitenuta: string = "";
    public readonly descrizioneRitenuta: string = "";
    public readonly codiceFiscaleIstituto: string = "";
    public readonly indirizzoIstituto: string = "";
    public readonly provinciaIstituto: string = "";
    public readonly comuneIstituto: string = "";
    public readonly capIstituto: string = "";
    public readonly contoCorrenteIstituto: string = "";
    public readonly abiIstituto: string = "";
    public readonly cabIstituto: string = "";
    public readonly ibanIstituto: string = "";
    public readonly cinIstituto: string = "";
    public readonly ultimaMensilitaEmessa: string = "";
    public readonly idConsultazioneSPT: string = "";

    constructor(data: Partial<IstitutoFinanziarioModel>) {
        super();

        this.update(data);
    }
}
